/* eslint-disable i18next/no-literal-string */
import Icon from "@/components/ui/icon.tsx";
import {
    ErrorAction,
    ErrorContainer,
    ErrorContent,
    ErrorMessage,
} from "@/features/sub-families/components/lib/error-components.tsx";

type Props = {
    onRetry: () => void;
    canRetry?: boolean;
};

export default function ErrorLoadingConfigurator({ onRetry, canRetry }: Props) {
    return (
        <ErrorContainer>
            <ErrorContent>
                {canRetry ? (
                    <>
                        <ErrorMessage>Something went wrong while loading the configurator.</ErrorMessage>
                        <ErrorAction onClick={onRetry}>
                            <Icon name="refresh" />
                            <span>Try again</span>
                        </ErrorAction>
                    </>
                ) : (
                    <ErrorMessage>We were unable to load the configurator...</ErrorMessage>
                )}
            </ErrorContent>
        </ErrorContainer>
    );
}
